// eslint-disable-next-line import/no-extraneous-dependencies
import { StackActions } from '@react-navigation/native'
import { Linking } from 'react-native'
import { trackEvent } from '../analytics'
import * as NavRefHelpers from '../navigators/NavigationRefHelpers'
import env from '../env'
import { log } from '../utils'

const setDetectedLocale = (locale) => ({
    type: 'SET_DETECTED_LOCALE',
    locale,
})

const getTrackEventID = (id) => {
    const currentRoute = NavRefHelpers.getCurrentRoute()
    let eventName = `${currentRoute}_${id}`
    if (eventName.length > 40) {
        eventName = eventName.slice(0, 40)
    }
    return eventName
}

const logTapEvent = async (eventName) => {
    try {
        await trackEvent(getTrackEventID(eventName))
    } catch (e) {
        // console.error(e)
    }
}

const resetAction = (routeName, params) => {
    NavRefHelpers.reset(routeName, params)
}

const trackEventAndNavigateToStack = (buttonName, stackName, initRouteName) => async () => {
    const eventName = getTrackEventID(buttonName)
    try {
        await trackEvent(eventName)
    } catch (e) {
        // console.log(e)
    }
    NavRefHelpers.navigate(stackName, { screen: initRouteName })
}

const trackEventAndPopToTop = (analyticId) => async () => {
  const eventName = getTrackEventID(analyticId || 'close')
    try {
        await trackEvent(eventName)
    } catch (e) {
        // console.log(e)
    }
    NavRefHelpers.navigationRef.current.dispatch(StackActions.popToTop())
}

const trackEventAndPop = (analyticId) => async () => {
  const eventName = getTrackEventID(analyticId || 'goBack')
    try {
        await trackEvent(eventName)
    } catch (e) {
        // console.log(e)
    }
    if (window.ReactNativeWebView && !NavRefHelpers.navigationRef.current.canGoBack()) {
      window.ReactNativeWebView.postMessage('pop')
    } else {
      NavRefHelpers.navigationRef.current.dispatch(StackActions.pop())
    }
}

const trackEventAndPopCount = async (numberOfScreens, id) => {
    const eventName = getTrackEventID(id)
    try {
        await trackEvent(eventName)
    } catch (e) {
        // console.log(e)
    }
    NavRefHelpers.goBackCount(numberOfScreens)
}

const trackEventAndNavigate = async (routeName, analyticId) => {
    const eventName = getTrackEventID(analyticId)
    try {
        await trackEvent(eventName)
    } catch (e) {
        // console.log(e)
    }
    NavRefHelpers.navigate(routeName)
}

const gotoSubPage = (pageName, pageId, callBackToNative) => {
    if (window.ReactNativeWebView && callBackToNative) {
        try {
            window.ReactNativeWebView.postMessage(`internalWeb;${pageName}`)
        } catch (ex) {
           // console.log('ex:', ex)
        }
    } else {
        trackEventAndNavigate(pageName, pageId)
    }
}

const gotoTab = (tabName, pageId) => {
  if (window.ReactNativeWebView) {
    try {
      window.ReactNativeWebView.postMessage(`gotoTab;${tabName}`)
    } catch (ex) {
      // console.log('ex:', ex)
    }
  } else {
    trackEventAndNavigate(tabName, pageId)
  }
}

const trackEventAndNavigateWithParams = async (analyticId, routeName, params) => {
  const eventName = getTrackEventID(analyticId)
    try {
        await trackEvent(eventName)
    } catch (e) {
        // console.log(e)
    }
    NavRefHelpers.navigate(routeName, params)
}

const trackEventAndReset = (analyticId, routeName) => async (dispatch) => {
  const eventName = getTrackEventID(analyticId)
    try {
        await trackEvent(eventName)
    } catch (e) {
        // console.log(e)
    }
    await resetAction(routeName, dispatch)
}

const trackEventByAnalyticId = (analyticId) => {
    trackEvent(getTrackEventID(analyticId))
}

const covidStudyWebTap = () => {
  trackEventByAnalyticId('covid19StudyFaq')
  const covidConfig = {
    covidStudyUrl: env.REACT_APP_COVID_URL,
    covidStudyApiUrl: env.REACT_APP_COVID_API_URL,
    covidStudyAuthToken: env.REACT_APP_COVID_AUTH_TOKEN,
  }
  const covidConfigStr = JSON.stringify(covidConfig)
  log(covidConfigStr)
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(`showCovidStudy;${btoa(covidConfigStr)}`)
  } else {
    Linking.openURL(env.REACT_APP_COVID_URL)
  }
}

export {
    covidStudyWebTap,
    gotoSubPage,
    gotoTab,
    logTapEvent,
    resetAction,
    setDetectedLocale,
    trackEventByAnalyticId,
    trackEventAndNavigate,
    trackEventAndNavigateToStack,
    trackEventAndPop,
    trackEventAndPopToTop,
    trackEventAndPopCount,
    trackEventAndNavigateWithParams,
    trackEventAndReset,
}
